import {isTest} from "../config";

/**
 * apph5
 */

const apph5_base_url = isTest() ? "https://apph5.jaadee.com" : "https://apph5test.jaadee.com";
/**
 * apph5 page 模块
 */
export const apph5_page =(val)=> {
  return  apph5_base_url+"/page/#/" + val
};

/**
 * apph5 app 模块
 */
export const apph5_app =(val)=> {
  return apph5_base_url+ "/appv2/" + val
};
export default {
  apph5_page,
  apph5_app,
}
